// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"84f1798b","949":"05968f44"}[chunkId] + ".chunk.js";
};